import { API_URLS } from "../Constants/api.constants";
import api from "./api";
import { errorHandling } from "./error.handling";

async function fetchAlerts(payload) {
  try {
    const queryParams = new URLSearchParams({
      StartDate: payload?.StartDate ?? "",
      EndDate: payload?.EndDate ?? "",
    });

    const response = await api.get(
      `${API_URLS.PROTOCOL_ALERTS}?${queryParams.toString()}`
    );

    const treated = errorHandling.handleResponse(
      response,
      "alertService.fetchAlerts"
    );
    if (treated?.error) return null;
    return Array.isArray(treated) ? treated : [];
  } catch (error) {
    errorHandling.cathError(error, "alertService.fetchAlerts");
    return null;
  }
}

async function fetchAlertDetails({ platformName, protocolId }) {
  try {
    const queryString = new URLSearchParams({
      PlatformName: platformName ?? "",
      ProtocolId: protocolId ?? "",
    });

    const response = await api.get(
      `${API_URLS.PROTOCOL_ALERTS_DETAILS}?${queryString.toString()}`
    );

    const treated = errorHandling.handleResponse(
      response,
      "alertService.fetchAlertDetails"
    );
    return Array.isArray(treated) ? treated : [];
  } catch (error) {
    errorHandling.cathError(error, "alertService.fetchAlertDetails");
    return [];
  }
}

async function createInteraction({ platformName, protocolId, interaction }) {
  try {
    const response = await api.post(API_URLS.PROTOCOL_ALERTS_DETAILS, {
      platformName,
      protocolId,
      interaction,
      function: "I",
    });

    return response?.status >= 200 && response.status < 300;
  } catch (error) {
    errorHandling.cathError(error, "alertService.createInteraction");
    return false;
  }
}

async function fetchProtocolStatuses() {
  try {
    const response = await api.get(API_URLS.PROTOCOL_ALERTS_STATUS);

    const treated = errorHandling.handleResponse(
      response,
      "alertService.fetchProtocolStatuses"
    );
    return Array.isArray(treated) ? treated : [];
  } catch (error) {
    errorHandling.cathError(error, "alertService.fetchProtocolStatuses");
    return [];
  }
}

async function updateProtocolStatus({ platformName, protocolId, protocolStatusId }) {
  try {
    const url = `${API_URLS.PROTOCOL_STATUS_BASE}/${protocolId}/status`;

    const response = await api.patch(url, {
      platformName,
      protocolStatusId,
    });

    return response?.status >= 200 && response.status < 300;
  } catch (error) {
    errorHandling.cathError(error, "alertService.updateProtocolStatus");
    return false;
  }
}

export const alertService = {
  fetchAlerts,
  fetchAlertDetails,
  createInteraction,
  fetchProtocolStatuses,
  updateProtocolStatus,
};
